import {useEffect, useState} from "react";
import fetcher from "../utils/fetcher";
import {
  EDIT_BASKET_RATE_SETTING_LIST_API,
  GET_BASKET_RATE_SETTING_LIST_API,
} from "../constants/api_constants";
import {accountInfo} from "../utils/constants";
import {ModalHandler, OpenModalHandle} from "../components/modal/ModalHandler";

const BasketManagementPage = () => {
  const [rateList, setRateList] = useState([]);
  const [initialRateList, setInitialRateList] = useState([]);
  const OpenModal = OpenModalHandle.create();

  useEffect(() => {
    getBasketRateSettingList();
  }, []);

  const getBasketRateSettingList = () => {
    // 최소 배당 설정 리스트 불러오기
    fetcher.get(GET_BASKET_RATE_SETTING_LIST_API + `?loginCode=${accountInfo.accountLoginCode()}`)
      .then(res => {
        const {responseIsSuccess, responseResultDescription, oddsRatioSettingList} = res.data;
        if (responseIsSuccess) {
          setRateList(oddsRatioSettingList);
          setInitialRateList(oddsRatioSettingList); // 초기값 저장
        } else {
          console.log(responseResultDescription);
        }
      })
      .catch((err) => {
        alert(err);
      });
  }

  const setBasketRateSettingList = (label, value) => {
    // 최소 배당값 수정
    fetcher.put(EDIT_BASKET_RATE_SETTING_LIST_API, {
      loginCode: accountInfo.accountLoginCode(),
      ratioLabel: label,
      ratioValue: value,
    }).then(res => {
      const {responseIsSuccess, responseResultDescription, updatedOddsRatioSetting} = res.data;
      if (responseIsSuccess) {
        // 기존 리스트에서 id가 같은 항목만 교체
        setRateList(prev =>
          prev.map(item => item.id === updatedOddsRatioSetting.id
            ? updatedOddsRatioSetting      // 서버에서 받은 값으로 교체
            : item
          )
        );

        // initialRateList 함께 업데이트 (저장된 값이 새로운 초기값으로)
        setInitialRateList(prev =>
          prev.map(item => item.id === updatedOddsRatioSetting.id
            ? updatedOddsRatioSetting
            : item
          )
        );

        OpenModal.openConfirmModal("변경 성공", responseResultDescription);
      } else {
        console.log(responseResultDescription);
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  return (
    <div className="flex flex-col w-full h-full pt-14 pb-32 items-center">
      <ModalHandler initModalHandle={OpenModal}/>

      <div className="w-[70rem] h-full">
        <h2 className="text-2xl font-semibold leading-tight mb-5">
          바구니 관리
        </h2>

        <div className="w-full h-full bg-white shadow-md p-20">
          <span className="text-lg">최소 배당 관리 리스트 </span>

          {rateList.map((list) => {
            // 초기값 찾기
            const originValue = initialRateList.find(item => item.id === list.id)?.ratioValue;

            return (
              <div key={list.id} className="flex items-center my-4">
                <span className="badge-style w-36 text-center">{list.ratioLabel}</span>

                <input
                  role="input"
                  value={list.ratioValue}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    // 값 변경 처리
                    setRateList(prev => prev.map(item => item.id === list.id ? {...item, ratioValue: newValue} : item));
                  }}
                  className="text-base leading-none text-gray-900 p-3
                 focus:outline-none focus:border-indigo-700
                 bg-gray-50 border rounded border-gray-300 mx-3"
                />

                <button
                  className={`button-style py-3 ${list.ratioValue === originValue ? "bg-gray-300 cursor-not-allowed" : ""}`}
                  disabled={list.ratioValue === originValue}
                  onClick={() => {
                    setBasketRateSettingList(list.ratioLabel, list.ratioValue);
                  }}
                >
                  저장
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}
export default BasketManagementPage;
